import {Injectable} from '@angular/core';
import {CanActivate, Router} from '@angular/router';
import {Observable} from 'rxjs/Observable';
import {AuthService} from './auth.service';
import {Auth, IAuth} from '../shared/auth';

@Injectable()
export class OnlyLoggedInGuard implements CanActivate {

  constructor(private router: Router, private authService: AuthService) {}

  canActivate() {
    return Observable.create((observer) => {
      this.authService.isLoggedIn().subscribe(
        (isLoggedIn: IAuth) => {
          const auth: IAuth = Auth.decode(sessionStorage.getItem('auth-credential'));

          if (!auth) {
            this.router.navigate(['/login']);

            if (isLoggedIn) {
              this.authService.logout();
            }

            observer.next(false);

          } else if (isLoggedIn || observer.isStopped) {
            observer.next(true);

          } else {
            this.authService.login(auth).subscribe(
              (isLogged: boolean) => {
                if (isLogged) {
                  observer.next(true);
                } else {
                  this.router.navigate(['/login']);
                  observer.next(false);
                }
              },
              (err) => {
                this.router.navigate(['/login']);
                observer.next(false);
              }
            );
          }
        }
      );
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/guard/only-logged-in.guard.ts